<template >
  <v-col class="pa-0">
    <v-row
      cols="12"
      sm="6"
      no-gutters
    >
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="datetimeModel"
        :disabled="disabled"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-combobox
            :hide-details="'auto'"
            v-model="datetimeModel"
            :label="label"
            :disabled="disabled"
            :prepend-icon="icon"
            :clearable="!required"
            color="primary"
            readonly
            :outlined="!disabled"
            :filled="disabled"
            v-bind="attrs"
            v-on="on"
            :rules="rules"
            @focus="openMenu"
            @click:clear="$emit('update:inputData', { $event });"
          >
            <template v-if="$slots.required" v-slot:prepend-inner>
              <slot name="required"></slot>
            </template>
          </v-combobox>
        </template>

        <v-card>
          <v-date-picker
            v-model="dateModel"
            no-title
            scrollable
            :locale="$i18n.locale"
            :first-day-of-week="1"
            :min="min"
            :max="max"
            :range="range"
            :hide-details="'auto'"
            @change="() => setDatetime(dateModel, null)"
          >
          </v-date-picker>

          <v-time-picker
            v-if="showTime"
            v-model="timeModel"
            format="24hr"
            :landscape="$vuetify.breakpoint.smAndUp"
            :hide-details="'auto'"
            ampm-in-title
            @change="() => setDatetime(dateModel, timeModel)"
          ></v-time-picker>
          <!-- En caso de volver a requerirse un cancelar y aceptar: -->
          <!-- Comentar la linea de arriba @change="() => setDatetime(dateModel, timeModel)" -->
          <!-- Y descomentar <v-card-actions> -->
          <!-- <v-card-actions>
            <v-input v-if="error">
              <label class="error--text v-messages">{{$t('validation.dateTime')}}</label>
            </v-input>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="menu = false"
            >
              {{ $t('commons.cancel') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="setDatetime(dateModel, timeModel)"
            >
              {{ $t('commons.ok') }}
            </v-btn>
          </v-card-actions> -->

        </v-card>
      </v-menu>
    </v-row>
  </v-col>
</template>

<script>
import moment from 'moment';

const transformDate = function transformDate(date) {
  let transform;
  switch (date) {
  case 'today':
    transform = moment();
    break;
  case 'tomorrow':
    transform = moment().add(1, 'days');
    break;
  case 'yesterday':
    transform = moment().add(-1, 'days');
    break;
  default:
    return date;
  }
  return transform.format('YYYY-MM-DD');
};

export default {
  props: {
    label: String,
    params: {
      type: Object,
      default: () => ({}),
    },
    initialValue: {
      required: false,
    },
    config: Object,
    required: {
      type: Boolean,
      default: () => false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },
  data() {
    return {
      menu: false,
      datetimeModel: null,
      dateModel: null,
      timeModel: null,
      min: this.params.min ? transformDate(this.params.min) : null,
      max: this.params.max ? transformDate(this.params.max) : null,
      range: !!this.params.range,
      icon: typeof this.params.icon === 'string' ? this.params.icon : null,
      error: false,
    };
  },
  computed: {
    showTime() {
      return this.params.timepicker === 'true';
    },
  },
  methods: {
    openMenu() {
      setTimeout(() => { // waiting for input transition time
        if (!this.$refs.menu.isActive) {
          this.$refs.menu.isActive = true;
        }
      }, 150);
    },
    formatDate(date, time) {
      const momentDate = moment(`${date} ${time || '00:00'}`, 'YYYY-MM-DD HH:mm');
      let value;
      if (this.params.format) {
        value = momentDate.format(this.params.format);
      } else if (this.showTime) {
        value = momentDate.format('YYYY-MM-DD HH:mm');
      } else {
        value = momentDate.format('YYYY-MM-DD');
      }
      return value;
    },
    setDatetime(date, time) {
      if ((this.showTime && time) || !this.showTime) {
        try {
          const dates = (typeof date === 'string' ? [date] : date)
            .sort((d1, d2) => (moment(d1).isSameOrAfter(d2) ? 1 : -1))
            .map((d) => this.formatDate(d, time));
          const value = dates.join(' - ');
          this.$refs.menu.save(value);
          this.$emit('update:inputData', { value, item: dates });
          this.error = false;
          return value;
        } catch (err) {
          this.error = true;
          return undefined;
        }
      } else {
        return undefined;
      }
    },
  },
  created() {
    const { initialValue } = this;
    if (typeof initialValue === 'string') {
      // only for filters
      if (initialValue.includes('::')) {
        this.datetimeModel = initialValue.split('::').map((k) => moment(k, 'YYYY-MM-DD').format('DD/MM/YYYY')).join(' - ');
        this.dateModel = initialValue.split('::');
      } else {
        const [date, time] = initialValue.split(' ');
        this.dateModel = transformDate(date);

        if (this.showTime) {
          this.timeModel = time;
        }
        this.datetimeModel = this.formatDate(this.dateModel, this.timeModel);
        this.$emit('update:inputData', { value: this.datetimeModel });
      }
    }
  },

  beforeDestroy() {
    this.$emit('update:inputData', {});
  },
};
</script>

<style lang="scss">

// eslint-disable-next-line max-len
.theme--light.v-text-field--outlined.v-input--is-disabled {
  &:not(.v-input--is-focused):not(.v-input--has-state) {
    > .v-input__control > .v-input__slot:hover {
      cursor: initial;
      background: rgba(0, 0, 0, 0.06);
    }
  }
}

</style>
